import * as React from 'react';
export const IcReturnOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.71 2.29a.996.996 0 00-1.41 0l-18.01 18a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2.15-2.15A8.955 8.955 0 0012 21.99c4.96 0 9-4.04 9-9 0-2.38-.94-4.53-2.45-6.14l3.16-3.16a.996.996 0 000-1.41v.01zM19 13c0 3.86-3.14 7-7 7-1.82 0-3.48-.71-4.72-1.86l9.86-9.86A6.953 6.953 0 0119 13.01V13zM11.29 7.7c.15.15.34.22.53.26l1.14-1.14a1.02 1.02 0 00-.26-.53l-.27-.27c.4.02.78.09 1.15.18l1.6-1.6c-.88-.33-1.81-.54-2.79-.58l.31-.31a.996.996 0 10-1.41-1.41l-2 2a.996.996 0 000 1.41l2 2V7.7zM5.19 14.59c-.12-.51-.19-1.05-.19-1.6s-.45-1-1-1-1 .45-1 1c0 1.12.22 2.2.6 3.19l1.6-1.6-.01.01z'
      fill='currentColor'
    />
  </svg>
);
